import React from 'react'

const ReviewHeroSection = () => {
  return (
    <section className="subheading" id="subheading">
        <div className="subheading__container subheading__container-1">
          <div className="c-grid">
            <div className="subheading__wrapper">
              <h1><span>
                  <p>03</p></span><span>
                  <p>(re)view</p></span></h1>
            </div>
          </div>
        </div>
        <div className="subheading__container subheading__container-2">
          <div className="c-grid">
            <p className="subheading__desc">Analytics and oversight of complete platform</p>
          </div>
        </div>
      </section>
  )
}


export default ReviewHeroSection
